import { Link } from "react-router-dom";
import { useState } from "react";
import api from "../../components/api";
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handlePasswordChange = (event) => {
        const value = event.target.value;
        setPassword(value);
        if (value.length < 8) {
            setPasswordError("Le mot de passe doit comporter au moins 8 caractères.");
        } else if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(value)) {
            setPasswordError("Une lettre et un chiffre minimum.");
        } else {
            setPasswordError("");
        }
    };

    const handleConfirmPasswordChange = (event) => {
        const value = event.target.value;
        setConfirmPassword(value);
        setConfirmPasswordError(value !== password ? "Les mots de passe ne correspondent pas !" : "")
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!password || !confirmPassword) {
            alert('Veuillez remplir tous les champs');
        } else {
            const resetData = {
                password: password,
                confirmPassword: confirmPassword,
            }

            // alert(confirmPassword);
            // alert(localStorage.getItem('token'));

            setLoading(true);
            
            try {
                // On suppose que `api` est une instance axios
                const response = await api.post('/reset_password', resetData,  {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });

                setLoading(false);


                console.log(response.data.message);

                alert('Votre mot de passe a été réinitialisé avec succès !');

                // Redirection vers le dashboard
                navigate('/dashboard');

            } catch (error) {
                console.error(error);
                alert('Une erreur est survenue, veuillez réessayer plus tard.');
            }


            // api.post('/reset_password', resetData) 
            // .then(response  => {
            //     console.log(response.data.message);
            //     alert('Votre mot de passe a été réinitialisé avec succès !');

            //     window.location('/dashboard');
            // })
            // .catch (error => {
            //     console.error(error);
            // });
        }


    };

    return (
        <>
            <div>
                <section className="py-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="card shadow-lg border-0">
                                    <div className="card-body">
                                        <div className="">
                                            <Link to="/" className="text-decoration-none">
                                                <img src="/images/COMMANDO.png" alt="Logo" width="100" height="100" className="d-inline-block align-text-top" />
                                            </Link>
                                        </div>
                                        <h2 className="fw-bold text-center">Réinitialisation du mot de passe</h2>
                                        <hr />
                                        <form>
                                            <div className="mb-3">
                                                <label htmlFor="password" className="form-label">Nouveau mot de passe</label>
                                                <input type="password" className="form-control" id="password" value={password} onChange={handlePasswordChange} />
                                                {passwordError && <div className="text-danger">{passwordError}</div>}
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="password" className="form-label">Confirmer le mot de passe</label>
                                                <input type="password" className="form-control" id="password" value={confirmPassword} onChange={handleConfirmPasswordChange} />
                                                {confirmPasswordError && <div className="text-danger">{confirmPasswordError}</div>}
                                            </div>

                                            {loading ? (
                                                <button className="btn text-white w-100" style={{ backgroundColor: "#f5721e" }} disabled>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Changement...</span>
                                                </button>
                                            ) : (

                                            <button type="submit" className="btn text-white w-100" onClick={handleSubmit} style={{ backgroundColor: "#f5721e" }}>Réinitialiser le mot de passe</button>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default ResetPassword;